function renderHTML(element, _a, styleProp, projection) {
    var style = _a.style, vars = _a.vars;
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for (var key in vars) {
        element.style.setProperty(key, vars[key]);
    }
}

export { renderHTML };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/render/html/utils/render.mjs
// module id = xrxq
// module chunks = 0